import { Phone, MessageCircle, Instagram, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { usePolicy } from "@/components/PolicyContext";
import { BUSINESS, NAV, MAPS_DIRECTIONS } from "@/data/site";
import { waGeneral } from "@/lib/wa";

export default function Footer() {
  const { open } = usePolicy();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-espresso text-ivory grain relative" data-testid="site-footer">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          {/* brand */}
          <div className="lg:col-span-4">
            <Logo className="h-10 sm:h-11 w-auto mb-5" testid="footer-logo" />
            <p className="eyebrow text-gold text-[11px] mb-4">{BUSINESS.descriptor}</p>
            <p className="text-ivory/60 text-sm max-w-xs leading-relaxed">
              Karatay, Konya’da güzellik, kuaför ve türban tasarımını aynı çatı altında
              buluşturan kişiye özel bir deneyim.
            </p>
          </div>

          {/* nav */}
          <div className="lg:col-span-3">
            <p className="eyebrow text-ivory/40 text-[10px] mb-5">Menü</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} data-testid={`footer-nav-${n.href.replace("#", "")}`} className="text-ivory/75 hover:text-gold text-sm transition-colors">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* contact */}
          <div className="lg:col-span-3">
            <p className="eyebrow text-ivory/40 text-[10px] mb-5">İletişim</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:${BUSINESS.phoneRaw}`} className="flex items-center gap-2 text-ivory/75 hover:text-gold transition-colors" data-testid="footer-phone">
                  <Phone size={15} className="text-gold" /> {BUSINESS.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={waGeneral()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-ivory/75 hover:text-gold transition-colors" data-testid="footer-whatsapp">
                  <MessageCircle size={15} className="text-gold" /> WhatsApp
                </a>
              </li>
              <li>
                <a href={BUSINESS.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-ivory/75 hover:text-gold transition-colors" data-testid="footer-instagram">
                  <Instagram size={15} className="text-gold" /> {BUSINESS.instagramHandle}
                </a>
              </li>
              <li>
                <a href={MAPS_DIRECTIONS} target="_blank" rel="noopener noreferrer" className="flex items-start gap-2 text-ivory/75 hover:text-gold transition-colors" data-testid="footer-address">
                  <MapPin size={15} className="text-gold mt-0.5 shrink-0" /> {BUSINESS.address}
                </a>
              </li>
            </ul>
          </div>

          {/* hours */}
          <div className="lg:col-span-2">
            <p className="eyebrow text-ivory/40 text-[10px] mb-5">Saatler</p>
            <ul className="space-y-2 text-sm">
              {BUSINESS.hours.map((h) => (
                <li key={h.day} className="text-ivory/70">
                  <span className="block text-ivory/50 text-xs">{h.day}</span>
                  {h.time}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-ivory/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-ivory/50 text-xs">© {year} {BUSINESS.name}. Tüm hakları saklıdır.</p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-ivory/60">
            <button onClick={() => open("gizlilik")} data-testid="footer-privacy" className="hover:text-gold transition-colors">Gizlilik Politikası</button>
            <button onClick={() => open("kvkk")} data-testid="footer-kvkk" className="hover:text-gold transition-colors">KVKK Aydınlatma Metni</button>
            <button onClick={() => open("cerez")} data-testid="footer-cookie" className="hover:text-gold transition-colors">Çerez Tercihleri</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
